function initSearchForm() {
    var searchForm = document.getElementById("search-submit-form");
    var addressInput = document.getElementById("adresa");

    if (searchForm !== null && addressInput !== null) {
        searchForm.addEventListener('submit', function(event) {
            event.preventDefault();
            addressInput.classList.remove("o-smartform-input--invalid")
            var address = $('#adresa');
            const adresa = address.val()
            const lat = address.data('lat')
            const lng = address.data('long')
            if(adresa && lat && lng) {
                window.location.href =
                    this.action
                    + '?address=' + adresa
                    + '&lat=' + lat
                    + '&long=' + lng
            } else {
                addressInput.classList.add("o-smartform-input--invalid")
            }
        }, false);
    }
}

$(document).ready(function () {
    initSearchForm()
})
